// Changelog: what each version of TowerClock changed, newest first, from CHANGELOG.md (built into
// the client, so it matches the version this phone is running).
import { Link } from "react-router-dom";
import { RELEASES, type Release } from "../lib/changelog";
import { APP_VERSION } from "../lib/version";

const DATE = new Intl.DateTimeFormat(undefined, {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

export function ChangelogScreen({ releases = RELEASES }: { releases?: Release[] }) {
  return (
    <main className="screen guide" data-screen="changelog">
      <header className="row" style={{ minHeight: 44 }}>
        <Link to="/" className="icon-btn" style={{ marginLeft: -8 }}>
          ← Home
        </Link>
      </header>

      <div className="stack-sm">
        <h1>Changelog</h1>
        <p className="muted">
          What changed in each version of TowerClock, newest first. This phone is running version{" "}
          {APP_VERSION}.
        </p>
      </div>

      {releases.map((r) => (
        <ReleaseSection key={r.version ?? "unreleased"} release={r} />
      ))}
    </main>
  );
}

function ReleaseSection({ release }: { release: Release }) {
  const { version, date } = release;
  return (
    <section className="guide-section release stack">
      <div className="row-between" style={{ alignItems: "baseline" }}>
        <h2>{version ?? "Unreleased"}</h2>
        {date && (
          <time className="small muted" dateTime={date}>
            {DATE.format(new Date(`${date}T00:00:00Z`))}
          </time>
        )}
      </div>
      {version === null && (
        <p className="small muted">Already here, but not yet part of a numbered version.</p>
      )}
      {release.groups.map((g) => (
        <div key={g.title} className="stack-sm">
          <h3 className="eyebrow">{g.title}</h3>
          <ul>
            {g.items.map((item, i) => (
              <li key={i}>
                <Entry text={item} />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}

/** One entry, with its `code` spans set in monospace. */
function Entry({ text }: { text: string }) {
  return <>{text.split("`").map((part, i) => (i % 2 ? <code key={i}>{part}</code> : part))}</>;
}
